import React from "react";
import { get, map } from "lodash";
import {Breadcrumb, Button, Checkbox, Icon, Modal} from "antd";

import classes from "./DocumentsEditor.css";
import DocumentForm from "../../components/DocumentForm/DocumentForm";
import {withNamespaces} from "react-i18next";

class FolderView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      categoryCode: null,
      subCategoryCode: null,
      contentTypeCode: null,
      documentEdit: null,
      showAllFolders: false,
    };
  }

  getDocuments = async () => {};

  onDocumentEditSubmit = () => {
    this.setState({ documentEdit: null, documentApproveId: null }, () => {
      this.getDocuments();
    });
  };

  render() {
    const { etmfSchema, etmfSchemaFilter } = this.props;
    const {
      categoryCode,
      subCategoryCode,
      contentTypeCode,
      documentEdit,
      showAllFolders,
    } = this.state;

    const etmfSchemaData = showAllFolders ? etmfSchema : etmfSchemaFilter;

    return (
      <div>
        <Checkbox
          onChange={() => {
            this.setState({
              showAllFolders: !this.state.showAllFolders,
            })
          }}
          checked={showAllFolders}
          disabled={!!categoryCode}
        >
          {this.props.i18n.t("NamespaceDocumentsEditor:Show all folders")}
        </Checkbox>

        <div style={{ margin: '20px 0 5px' }}>
          {this.props.filters}
        </div>

        <Breadcrumb style={{ margin: "24px 0 8px" }}>
          <Breadcrumb.Item
            className={classes.breadcrumbItem}
            onClick={() => {
              this.setState({
                categoryCode: null,
                subCategoryCode: null,
                contentTypeCode: null,
              });
              this.props.clearContentTypeCode();
            }}
          >
            {this.props.i18n.t("NamespaceDocumentsEditor:/Root")}
          </Breadcrumb.Item>

          {categoryCode && (
            <Breadcrumb.Item
              className={classes.breadcrumbItem}
              onClick={() => {
                this.setState({
                  subCategoryCode: null,
                  contentTypeCode: null,
                });
                this.props.clearContentTypeCode();
              }}
            >
              {categoryCode.name}
            </Breadcrumb.Item>
          )}

          {subCategoryCode && (
            <Breadcrumb.Item
              className={classes.breadcrumbItem}
              onClick={() => {
                this.setState({
                  contentTypeCode: null,
                });
                this.props.clearContentTypeCode();
              }}
            >
              {subCategoryCode.name}
            </Breadcrumb.Item>
          )}

          {contentTypeCode && (
            <Breadcrumb.Item
              className={classes.breadcrumbItem}
              onClick={() => {
                // this.setState({
                //   contentTypeCode: null,
                // });
              }}
            >
              {contentTypeCode.name}
            </Breadcrumb.Item>
          )}
        </Breadcrumb>

        {categoryCode === null &&
          map(get(etmfSchemaData, "schema", []), ({ name, code }, index) => (
            <div
              key={code}
              className={classes.folderItem}
              onClick={() => {
                this.setState({ categoryCode: { code, index, name } });
              }}
            >
              <Icon type="folder" className={classes.folderIcon} />
              {name} <span className={classes.folderCode}>(code: {code})</span>
            </div>
          ))}

        {subCategoryCode === null &&
          categoryCode &&
          map(
            get(etmfSchemaData, `schema[${categoryCode.index}].sub_categories`, []),
            ({ name, code }, index) => (
              <div
                key={code}
                className={classes.folderItem}
                onClick={() => {
                  this.setState({ subCategoryCode: { code, index, name } });
                }}
              >
                <Icon type="folder" className={classes.folderIcon} />
                {name}{" "}
                <span className={classes.folderCode}>(code: {code})</span>
              </div>
            )
          )}

        {contentTypeCode === null &&
          categoryCode &&
          subCategoryCode &&
          map(
            get(
              etmfSchemaData,
              `schema[${categoryCode.index}].sub_categories[${subCategoryCode.index}].content_types`,
              []
            ),
            ({ name, code }, index) => (
              <div
                key={code}
                className={classes.folderItem}
                onClick={() => {
                  this.setState({ contentTypeCode: { code, index, name } });
                  this.props.setContentTypeCode(code);
                }}
              >
                <Icon type="folder" className={classes.folderIcon} />
                {name}{" "}
                <span className={classes.folderCode}>(code: {code})</span>
              </div>
            )
          )}

        {this.props.addDocumentWithParams && contentTypeCode && (
          <div>
            {this.props.documentCreatePermission && (
              <div>
                <Button
                  type="primary"
                  onClick={() => {
                    this.props.addDocumentWithParams({
                      primary_category_code: categoryCode.code,
                      sub_category_code: subCategoryCode.code,
                      content_type_code: contentTypeCode.code,
                    });
                  }}
                >
                  {this.props.i18n.t("NamespaceDocumentsEditor:Add new document")}
                </Button>
                <br />
              </div>
            )}
          </div>
        )}
        <br />
      </div>
    );
  }
}

export default withNamespaces()(FolderView);



// WEBPACK FOOTER //
// ./src/containers/DocumentsEditor/FolderView.js